import enMessages from "./en";

const deMessages = Object.keys(enMessages).reduce((messages, key) => {
  messages[key] = key;
  return messages;
}, {});

export default deMessages;
